import {
  IconCircleAdd,
  IconCircleMinus,
  IconStack,
  IconPencil,
  IconMenuVertical,
} from "Icons";
import React, { useState } from "react";
import css from "./card-group.module.scss";
import classNames from "classnames";
import { Button,OverlayTooltip,InputField } from "components";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import { withLabelsContext } from "context";
import { rgba } from "polished";

const StyledCardWrapper = styled.div`
&& {
  .${css.colorstyle} {
    background: linear-gradient(180deg, ${({ theme }) => rgba(theme.color4, 0.3)} 0%, #fff 100%);
    svg{
      fill: ${({ theme }) => rgba(theme.color3, 0.5)}
    }
  
  }
  .${css.number} {
    background: linear-gradient(90deg, ${({ theme }) => theme.color3} 0%, ${({ theme }) => theme.color4} 100%);

  }
}
`;

const StyledDropdownMenu = styled.div`
  width: 176px;
  padding-left: 10px;
  padding-right: 10px;
  color: #001b4a;
  text-align: initial;
  .dropdown-item {
    padding: 8px 5px;
    font-size: 12px;
    border-bottom: 1px dashed #979797;

    a {
      color: #001b4a;
    }

    svg {
      width: 16px;
      height: 16px;
      fill: #aeafad;
    }

    &:active,
    &:hover {
      background-color: #e9ecef;
      color: inherit;
    }

    &:last-child {
      border-bottom: none;
    }
  }
`;

function CardGroup(props) {
  const [isOpen, setOpen] = useState(false);
  const [controlsVisible, setControlsVisible] = useState(false);

  const CustomDropdownToggle = React.forwardRef(
    ({ children, onClick }, ref) => (
      <span
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </span>
    )
  );
 
 const handleClick = (e) => {
  props.onSelectEntity(e, "chapter", props.chapter,props.number)
     setOpen(!isOpen);
  }

  const handleClick1 = (e) => {
    // props.onSelectEntity(e, "chapter", props.chapter,props.number)
       setOpen(!isOpen);
    }

    const handleClick2 = (e) => {
      console.log(e,props.chapter);
      props.onClick(e,props.chapter)
      setOpen(!isOpen);  
   }
  
   const handleSequenceChange = (e) => {
    e.stopPropagation()
    props.onChapterSequence(e.target.value, props.chapter.id, props.number)
  }

  const DropdownMenu = (row) => {
    const dropDownListDisplay = [
      {
        label: `Delete ${props.ctx_labels.singular.chapter}`,
        onClick: (e) => props.onDeleteEntity(e, "chapter", props.chapter,props.number)
      },
      {
        label: `Add ${props.ctx_labels.singular.module}`,
        onClick: (e) => props.onAddModule(e, "module", props.chapter)
      },
      {
        label: `Add ${props.ctx_labels.singular.assessment}`,
        onClick: (e) => props.onAddTest(e, "test", props.chapter)
      },
      {
        label: `Add ${props.ctx_labels.singular.survey}`,
        onClick: (e) => props.onAddSurvey(e, "survey", props.chapter)
      },
      {
        label: `Update Sequence`,
        onClick: (e) => props.sequenceUpdate(e, props.chapter),
        disabled: true
      }
    ].filter(item => 
    
       props.activeEntityDetails &&
       props.activeEntityDetails.parentId === props.chapter.courseContentId ? item:
       
       props.activeEntityDetails &&
       props.activeEntityDetails.id === props.chapter.id && props.chapter.contents.length === 0  ? 
       item.label !== `Update Sequence`  : 
       props.activeEntityDetails && props.activeEntityDetails.courseContentId !== props.chapter.courseContentId  ? 
       item.label ===  `Delete ${props.ctx_labels.singular.chapter}` :
       props.modifiable === 0 && props.createdId && props.createdId.toString() !== props.createrId ?
       item.label !==  `Add ${props.ctx_labels.singular.assessment}` && item.label!== `Add ${props.ctx_labels.singular.module}`
       : true

        )

       

    return (
      // !props.activeEntityDetails &&                     //disable condition
      <Dropdown drop="right">
        {!props.chapterProgress &&
        <Dropdown.Toggle as={CustomDropdownToggle} id="dropdown-basic">
          <div className={classNames(  props.activeEntityDetails && 
          props.activeEntityDetails.id === props.chapter.id ?
          css.menuId : css.menu)}>
          <Button iconOnly variant="white" size="sm" pill className="px-2 mr-1">
            <IconMenuVertical/>
          </Button>
          </div>
        </Dropdown.Toggle>
  }

        {
        props.editSeq === true ?
        
        <Dropdown.Menu>
          <StyledDropdownMenu>
            {
             dropDownListDisplay.map((dropdown, i) => {
              return <Dropdown.Item onClick={dropdown.onClick}>{dropdown.label}</Dropdown.Item>;
            })}
          </StyledDropdownMenu>
        </Dropdown.Menu>
      :
      <Dropdown.Menu>
      <StyledDropdownMenu>
        {
         dropDownListDisplay.map((dropdown, i) => {
          return <Dropdown.Item onClick={dropdown.onClick}>{dropdown.label}</Dropdown.Item>;
        })}
      </StyledDropdownMenu>
    </Dropdown.Menu>
     }
  </Dropdown>
    );
  };

  return (
    <StyledCardWrapper
      className={classNames(css.wrapper, props.preview && css.wrapper_shadow )}
    >
     {  props.modifiable === 0 && props.createdId && props.createdId.toString() !== props.createrId ?
     <OverlayTooltip placement="top"  tip={props.ctx_labels.singular.chapternotModifiable}>
       <div
      // className={css.header}
        className={classNames(
          props.activeEntityDetails && 
          props.activeEntityDetails.parentId === props.chapter.courseContentId ||
          props.activeEntityDetails && props.activeEntityDetails.id === props.chapter.id ?
           css.colorstyle : css.header )}
        onClick={ 
          props.modifiable === 0 && props.createdId && props.createdId.toString() === props.createrId ? handleClick : 
          props.modifiable === 1 && props.createdId && props.createdId.toString() !== props.createrId ? handleClick :   
           props.modifiable === 1 && props.createdId && props.createdId.toString() === props.createrId ? handleClick :
           props.modifiable === 0 && props.createdId && props.createdId.toString() !== props.createrId ? handleClick1 :
        props.chapterProgress && handleClick2}

      >
 <span className={css.number}>{props.number}</span>
        <div className={css.title}>{props.title}</div>
        {props.date && <span className={css.number}>{props.date}</span>}
        <DropdownMenu />
        
        {props.total && (
          <span className={`${css.total} bg-color3`}>
            <IconStack />
            {props.total}
          </span>
        )}
        <span className={css.toggle} style={{marginTop: "-10px"}}>
          {isOpen ? <IconCircleMinus /> : <IconCircleAdd />}
        </span>
        {/* <span><InputField
        // id={items.itemName}
        type="number"
        className="c-build-seq"
        value={props.number}
        min="1"
        label="Sequence"
        onChange={handleSequenceChange} 
        onClick ={(e) => e.stopPropagation()}
        /></span> */}
      </div>
      </OverlayTooltip> :
      <div
      // className={css.header}
        className={classNames(props.activeEntityDetails && 
          props.activeEntityDetails.parentId === props.chapter.courseContentId ||
          props.activeEntityDetails && props.activeEntityDetails.id === props.chapter.id ?
           css.colorstyle : css.header )}
           onClick={ 
            props.modifiable === 0 && props.createdId && props.createdId.toString() === props.createrId ? handleClick : 
            props.modifiable === 1 && props.createdId && props.createdId.toString() !== props.createrId ? handleClick :   
             props.modifiable === 1 && props.createdId && props.createdId.toString() === props.createrId ? handleClick :
             props.modifiable === 0 && props.createdId && props.createdId.toString() !== props.createrId ? handleClick1 :
              props.chapterProgress && handleClick2}
      >
        <span className={css.number}>{props.number}</span>
        <div className={css.title}>{props.title}</div>
        {props.date && <span className={css.number}>{props.date}</span>}
        {/* <Button
          iconOnly
          variant="white"
          size="sm"
          className="mr-1 ml-0"
          onClick={(e) => props.onSelectEntity(e, "chapter", props.chapter)}
        > */}
        <DropdownMenu />
        {/* <IconChevronDown
          onClick={(e) => {
            e.stopPropagation();
            setControlsVisible((prevState) => !prevState);
          }}
        /> */}
        {/* </Button> */}
        {props.total && (
          <span className={`${css.total} bg-color3`}>
            <IconStack />
            {props.total}
          </span>
        )}
        <span className={css.toggle}  style={{marginTop: "-10px"}}>
          {isOpen ? <IconCircleMinus /> : <IconCircleAdd />}
        </span>
    
      </div>}
      {props.isContentBuilder &&
            <div style={{marginLeft:"250px",marginTop: "-20px"}}><InputField
            // id={items.itemName}
            type="number"
            className="c-build-seq"
            value={props.number}
            min="1"
            label="Sequence"
            onChange={handleSequenceChange} 
            onClick ={(e) => e.stopPropagation()}
            /></div>
      }
      {controlsVisible && (
        <div className={css.header}>
          <Button
            iconOnly
            variant="white"
            size="sm"
            className="mr-1 ml-0"
            onClick={(e) => props.onSelectEntity(e, "chapter", props.chapter)}
          >
            <IconPencil />
          </Button>
        </div>
      )}
      {isOpen && <div className={css.cards}>{props.children}</div>}
    </StyledCardWrapper>
  );
}

export default withLabelsContext(CardGroup);